

export type OrgTab = 'members' | 'policies' | 'billing' | 'vcs-trust' | 'access-rules' | 'notifications'

/** The settings tabs, in the order they are rendered.
 *
 *  These keys are URL: OrgPage reads `?tab=` so a settings section can be linked to directly, which
 *  is why `vcs-trust` keeps its slug even though it reads as "Pipeline Trust". The labels used to
 *  be derived from the keys by capitalising them, with vcs-trust special-cased - which meant the
 *  rendered order and this file's order could drift apart, and had. */
export const ORG_TABS: { key: OrgTab; label: string }[] = [
  { key: 'members',       label: 'Members' },
  { key: 'policies',      label: 'Policies' },
  { key: 'billing',       label: 'Billing' },
  { key: 'notifications', label: 'Notifications' },
  { key: 'vcs-trust',     label: 'Pipeline Trust' },
  { key: 'access-rules',  label: 'Access Rules' },
]
